import React from 'react'
import ApiBidding from '../code/api/ApiBidding';
import BidPlan from '../code/models/BidPlan';
import Customer from '../code/models/Customer';
import { stringToDateTime } from '../code/helpers/stringToDate';
import CclDataTable, { CclDataTableColumnType, CclDataTableColumnDef } from './CclDataTable';
import Api_Config from '../code/api/ApiConfig';
import { ApiConfigCompany, BidNavVersion } from '../code/models/ApiConfigCompany';
import AuthAdminUserModel from "../code/models/AuthAdminUserModel";
import BidPlanResult from "../code/models/BidPlanResult";
import CustomerInfoBidPlan from "./CustomerInfoBidPlan";
import '../css/customerinfobiddingplans.css';
import { useReactToPrint } from 'react-to-print';


interface ICustomerInfoBiddingPlans {
    customer: Customer;
    currentUser: AuthAdminUserModel;
}

export default function CustomerInfoBiddingPlans({ customer, currentUser }: ICustomerInfoBiddingPlans) {
    const [bidPlans, setBidPlans] = React.useState<BidPlan[] | null>(null);
    const [planResult, setPlanResult] = React.useState<BidPlanResult | null>(null);
    const [currentCompany, setCurrentCompany] = React.useState<ApiConfigCompany>();

    React.useEffect(() => {
        loadProfiles();
        setCurrentCompany(Api_Config.getSelectedCompany());
    }, []);

    async function loadProfiles() {
        ApiBidding.getBidPlans(customer.customerId).then(data => {
            setBidPlans(data);
        });
    }

    function formatDate(val: any): string {
        return `${stringToDateTime(val + "")}`;
    }

    function openInNewTab(url: string) {
        window.open(url, "_blank", "noreferrer");
    };

    function handleButtonClick(rowData: any, buttonName: string) {
        if (buttonName === "viewbidplan") {
            let company = Api_Config.getSelectedCompany();
            if (company.bidNavVersion === BidNavVersion.BidNav20) {
                ApiBidding.getBidPlan(customer.customerId, rowData.planId).then((plan) => {
                    setPlanResult(plan);
                });
            } else {
                openInNewTab(`${currentCompany?.bidNavUrl}/api/bidding/GetBiddingPlanByRun?runId=${rowData.id}`);
            }
        }
    }

    const printRef = React.useRef(null);
    const printIt = useReactToPrint({ contentRef: printRef });

    function buildPlanForm() {
        return (
            <div className="container-fluid row h-100">
                <div className="col-md-1 h-100">
                    <button onClick={() => setPlanResult(null)} className="btn btn-outline-primary pad-top-10">Close</button>
                    <br />
                    <button onClick={() => printIt()} className="btn btn-outline-success pad-top-10">Print</button>
                </div>
                <div className="col-md-11 h-100 print-ref" ref={printRef}>
                    {!!planResult && <CustomerInfoBidPlan bidPlanResult={planResult} />}
                </div>
            </div>
        )
    }

    const bidPlanColumnDefs: CclDataTableColumnDef[] = [
        {
            type: CclDataTableColumnType.Data,
            fieldName: "bidMonth",
            title: "Bid Month",
            visible: true,
            className: "customer-bidding-plan-month-cell"
        },
        {
            type: CclDataTableColumnType.Data,
            fieldName: "profileName",
            title: "Profile",
            visible: true
        }, {
            type: CclDataTableColumnType.Data,
            fieldName: "requestStatus",
            title: "Request Status",
            visible: true
        }, {
            type: CclDataTableColumnType.Data,
            fieldName: "requestDateTime",
            title: "Request Time",
            visible: true,
            formatData: formatDate
        }, {
            type: CclDataTableColumnType.Button,
            fieldName: "",
            buttonName: "viewbidplan",
            buttonText: "View Plan",
            title: "View Plan",
            visible: true,
            buttonClassName: "btn btn-sm btn-outline-primary"
        }
    ];

    return (
        <React.Fragment>
            {!!planResult && buildPlanForm()}
            {!planResult &&
                <div className='customer-bidding-plans-table-wrapper'>
                    <CclDataTable
                        name={"profilesTable"}
                        tableData={bidPlans || []}
                        columnDefinitions={bidPlanColumnDefs}
                        rowSelect={false}
                        onRowSelect={null}
                        onButtonClick={handleButtonClick} />
                </div>}
        </React.Fragment>
    )
}
